import { writable } from "svelte/store";
const { subscribe, set, update } = writable(null);
export const doctorStore = {
    subscribe,
    set,
    update,
};
